module.exports = __webpack_public_path__ + "static/media/roger-square.bd71e1c8.jpg";